export default "__VITE_ASSET__BjTBxIHr__"